import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import { formatMoney } from '@experience/money-utils';

import type ru from '../../i18n/ru.json';
import { useComponentI18n } from '@/shared/composables/useComponentI18n';
import { tripsterStandard } from '@experience/money-utils/dist/numbers/tripsterStandard';
import { type CurrencyCode, getCurrencySymbol } from '@/shared/lib/currency';

interface UseFilterPriceTitleProps {
  messages: TSchema;
  currencyCode: CurrencyCode;
}

type TSchema = typeof ru;
export function useExcursionFilterPriceTitle({ messages, currencyCode }: UseFilterPriceTitleProps) {
  const { t } = useComponentI18n({ ru: messages });

  const filterStore = useExcursionFiltersStore();

  const DEFAULT_TITLE = t('price.defaultTitle');

  const headerTitle = computed(() => {
    return t('price.headerTitle', { currentSign: currentSign.value });
  });

  const currentSign = computed(() => getCurrencySymbol(currencyCode));

  const title = computed(() => {
    const price = filterStore.searchState.price;

    const [firstPrice, secondPrice] = price;

    if (firstPrice === null && secondPrice === null) {
      return DEFAULT_TITLE;
    }

    if (firstPrice && secondPrice === null) {
      return t('price.fromPriceTitle', {
        price: formatMoney(firstPrice, currencyCode),
      });
    }

    if (secondPrice && firstPrice === null) {
      return t('price.toPriceTitle', {
        price: formatMoney(secondPrice, currencyCode),
      });
    }

    if (firstPrice && secondPrice) {
      return firstPrice === secondPrice
        ? formatMoney(secondPrice, currencyCode)
        : formatMoney(`${tripsterStandard(firstPrice)}–${tripsterStandard(secondPrice)}`, currencyCode);
    }

    return DEFAULT_TITLE;
  });

  const isActive = computed(() => title.value !== DEFAULT_TITLE);

  return {
    title,
    headerTitle,
    isActive,
  };
}
